<ui-view>
	<div [ngClass]="styles.gridLayout" [style.grid-template-columns]="rowStyle">
		<a *ngFor="let video of videos" uiSref=".play" [uiParams]="{ videoId: video.id }" (click)="onVideoClick(video)">
			<div class="fixed-ratio" [style.background-image]="video.thumbnailBg">
				<span *ngIf="video.duration >= 0" [ngClass]="styles.durationOverlay">
					{{ video.duration | vbTimespan }}
				</span>
			</div>
			<span>
				{{video.title}}
			</span>
		</a>
	</div>
</ui-view>
<div [ngClass]="styles.currentVideoTitle">
	<span> {{ currentVideo?.title }} </span>
	<a *ngIf="uiRouterGlobals.current.name === 'embedPlaylist.grid.play'" uiSref="embedPlaylist.grid" (click)="onBackClick()">
		<span class="vb-icon vb-icon-center vb-icon-undo" [attr.aria-label]="UI_BackButton | translate">
		</span>
	</a>
</div>
